import React from "react";
import TableText from "@/components/table/TableText";
import { numConvert, calculation, sum } from "@/method";
import _ from 'lodash'
import moment from 'moment'

const totalIndex = [0, 6, 12];
const inputIndex = [1, 2, 4, 7, 8, 10, 13, 14, 16];
const percentIndex = [2, 8, 14];
const getType = (index, print) => {
    if (percentIndex.includes(index) && inputIndex.includes(index) && !print) return "inputPercent"
    if (percentIndex.includes(index)) return "percent"
    if (inputIndex.includes(index) && !print) return "inputNumber"
    return "number"
}

export default (data, { date, last, e4_1_1 }) => {
    const month = moment(date).format('M');
    const nameGrandData = {
        1: "grand_rn",
        2: "grand_occ",
        3: "grand_arr",
        4: "grand_rev",
        5: "grand_revpar",
        7: "grand_rn",
        8: "grand_occ",
        9: "grand_arr",
        10: "grand_rev",
        11: "grand_revpar",
        13: "grand_rn",
        14: "grand_occ",
        15: "grand_arr",
        16: "grand_rev",
        17: "grand_revpar",
    };
    Object.keys(nameGrandData).map(i => {
        const _month = i < 7 ?
            month
            :
            i < 13 ?
                ~~month + 1 : ~~month + 2;
        data[i].forecast = _.get(e4_1_1, `${(_month - 1) * 3 + 1}.${nameGrandData[i]}`, 0);
        data[i].budget = _.get(e4_1_1, `${(_month - 1) * 3}.${nameGrandData[i]}`, 0);
        data[i].last = _.get(e4_1_1, `${(_month - 1) * 3 + 2}.${nameGrandData[i]}`, 0);
    });

    data[3].otb = calculation(data[4].otb, data[1].otb);
    data[5].otb = (data[2].otb * data[3].otb).toFixed(2);

    data[9].otb = calculation(data[10].otb, data[7].otb);
    data[11].otb = (data[8].otb * data[9].otb).toFixed(2);

    data[15].otb = calculation(data[16].otb, data[13].otb);
    data[17].otb = (data[14].otb * data[15].otb).toFixed(2);

    // 计算vs one
    data.forEach((item, i) => {
        data[i].otbForecast = (item.otb - item.forecast).toFixed(4);
        data[i].otbBudget = (item.otb - item.budget).toFixed(4);
        data[i].otbLast = (item.otb - item.last).toFixed(4);

        data[i].otbForecastS = calculation(data[i].otbForecast, item.forecast, 4);
        data[i].otbBudgetS = calculation(data[i].otbBudget, item.budget, 4);
        data[i].otbLastS = calculation(data[i].otbLast, item.last, 4);
    });

    // 填充昨日数据 
    data.forEach((item, i) => {
        data[i].dayPU = (item.otb - _.get(last, `${i}.otb`, 0)).toFixed(4);
    });

    //   daily计算
    data[3].dayPU = calculation(data[4].dayPU, data[1].dayPU);
    data[5].dayPU = (data[2].dayPU * data[3].dayPU).toFixed(2);

    data[9].dayPU = calculation(data[10].dayPU, data[7].dayPU);
    data[11].dayPU = (data[8].dayPU * data[9].dayPU).toFixed(2);

    data[15].dayPU = calculation(data[16].dayPU, data[13].dayPU);
    data[17].dayPU = (data[14].dayPU * data[15].dayPU).toFixed(2);

    return data
}

export const columns = (onChange, date, print) => {
    return [
        {
            title: ``,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const props = {
                    text,
                    index,
                    type: 'text',
                    name: "name",
                    onChange,
                    totalIndex,
                };
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 12
                    },
                    children: <TableText data={props} />
                }
                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `OTB`,
            dataIndex: 'otb',
            key: 'otb',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['OTB'];
                const props = {
                    text,
                    index,
                    type: getType(index, print),
                    name: "otb",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_4_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
        {
            title: `Forecast`,
            dataIndex: 'forecast',
            key: 'forecast',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['Forecast'];
                const props = {
                    text,
                    index,
                    type: getType(index, true),
                    name: "forecast",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_4_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "OTB VS Forecast",
            children: [{
                dataIndex: 'otbForecast',
                key: 'otbForecast',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS Forecast'];
                    const props = {
                        text,
                        index,
                        type: getType(index, true),
                        name: "otbForecast",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                dataIndex: 'otbForecastS',
                key: 'otbForecastS',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS Forecast'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "otbForecastS",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `Budget`,
            dataIndex: 'budget',
            key: 'budget',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['Budget'];
                const props = {
                    text,
                    index,
                    type: getType(index, true),
                    name: "budget",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_4_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "OTB VS Budget",
            children: [{
                dataIndex: 'otbBudget',
                key: 'otbBudget',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS Budget'];
                    const props = {
                        text,
                        index,
                        type: getType(index, true),
                        name: "otbBudget",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                dataIndex: 'otbBudgetS',
                key: 'otbBudgetS',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS Budget'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "otbBudgetS",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        },
        {
            title: `LY`,
            dataIndex: 'last',
            key: 'last',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['LY'];
                const props = {
                    text,
                    index,
                    type: getType(index, true),
                    name: "last",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_4_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: "OTB VS LY",
            children: [{
                dataIndex: 'otbLast',
                key: 'otbLast',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS LY'];
                    const props = {
                        text,
                        index,
                        type: getType(index, true),
                        name: "otbLast",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }, {
                dataIndex: 'otbLastS',
                key: 'otbLastS',
                align: "center",
                width: 100,
                render: (text, record, index) => {
                    if (totalIndex.includes(index)) return {
                        props: {
                            colSpan: 0
                        },
                    }
                    const title = ['OTB VS LY'];
                    const props = {
                        text,
                        index,
                        type: 'percent',
                        name: "otbLastS",
                        onChange,
                        totalIndex,
                        compared: {
                            title,
                            record,
                            sqlName: "_4_2_4_day"
                        }
                    };

                    return (
                        <TableText data={props} />
                    )
                }
            }]
        }, {
            title: `Daily P/U`,
            dataIndex: 'dayPU',
            key: 'dayPU',
            align: "center",
            width: 100,
            render: (text, record, index) => {
                if (totalIndex.includes(index)) return {
                    props: {
                        colSpan: 0
                    },
                }
                const title = ['Daily P/U'];
                const props = {
                    text,
                    index,
                    type: getType(index, true),
                    name: "dayPU",
                    onChange,
                    totalIndex,
                    compared: {
                        title,
                        record,
                        sqlName: "_4_2_4_day"
                    }
                };

                return (
                    <TableText data={props} />
                )
            }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/components/table/4.0/4-2/4.2.4/compute.js